var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgHandStop = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 94,
  height: 93,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FB5656",
  d: "M85.75 46.5c0 21.4-17.35 38.75-38.75 38.75S8.25 67.9 8.25 46.5 25.6 7.75 47 7.75 85.75 25.1 85.75 46.5"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#FCB115",
  d: "M70.638 47.275a3.88 3.88 0 0 0-5.425.775l-6.588 8.783V26.156c0-1.606-1.3-2.906-2.906-2.906a2.905 2.905 0 0 0-2.907 2.906v18.407h-1.937V22.28c0-1.606-1.3-2.906-2.906-2.906a2.905 2.905 0 0 0-2.907 2.906v22.282h-1.937V24.219c0-1.606-1.3-2.907-2.906-2.907a2.905 2.905 0 0 0-2.907 2.907v20.344h-1.937V30.03c0-1.606-1.3-2.906-2.906-2.906a2.905 2.905 0 0 0-2.907 2.906v33.907a5.81 5.81 0 0 0 5.813 5.812h18.406c3.032 0 5.93-1.45 7.75-3.875L71.412 52.7a3.876 3.876 0 0 0-.775-5.425"
})));
export default SvgHandStop;